export const environment = {
	production: false,
    clientUrl:'https://vinculacioneslab.admin.lipatinantioquia.com.co',
    msalConfig: {
        auth: {
            clientId: 'b1901e92-2103-4988-a470-00530fb3adb1',
            authority: 'https://login.microsoftonline.com/4c23a29a-4620-4d97-88e0-0670df67d7ad',
            redirectUri:'https://vinculacioneslab.admin.lipatinantioquia.com.co',
            redirectLogoutUri:'https://vinculacioneslab.admin.lipatinantioquia.com.co'
        }
    },
    apiConfig: {
        scopes: ['user.read'],
        uri: 'https://graph.microsoft.com/v1.0/me'
    },
    roles:{
        adminRole:'SID_ADMINISTRATOR',
        gestionRole:'SID_GESTOR',
        instructorRole:'ACADEMY_INSTRUCTOR',
        checkerRole:'SID_CHECKER',
        gestionEventosRole:'SID_EVENT_GESTOR',
        adminEventosRole:'SID_EVENT_ADMIN',
        financialGestorRole:'SID_FINANCIAL_GESTOR'
    },
    academyApi:{
        applications:'https://apim-lipatin-lab-001.azure-api.net/carnetdigital',
        documents:'https://apim-lipatin-lab-001.azure-api.net/carnetdigital',
        registration:'https://apim-lipatin-lab-001.azure-api.net/carnetdigital',
        administration:'https://apim-lipatin-lab-001.azure-api.net/carnetdigital',
        gestion:'https://apim-lipatin-lab-001.azure-api.net/carnetdigital',
        competition:'https://apim-lipatin-lab-001.azure-api.net/carnetdigital'
    },
    academyPortals:{
        applications:'https://vinculacioneslab.lipatinantioquia.com.co'
    },
    apiManagementConfig:{
        carnetdigitalApi: '06a7e8478e204c849f45d1ad754c7063'
    }
};